import React, { useContext } from "react";
import { IconAtom2 } from "../atoms/iconAtom";
import { UserContext } from "../App";

export function EmptyComp({ userName, userID, currentUserID, navigationContext, customScreen }) {
  const userInformation = useContext(UserContext);
  
  const getEmptyState = () => {
    if (customScreen) {
      return customScreen;
    }

    const isUserLoggedIn = userID !== undefined;
    const isCurrentUser = userID === currentUserID;
    const isPublic = userInformation.account_type === 1;

    if (!isUserLoggedIn) {
      return {
        title: `Je heb nog geen cursussen`,
        description: "Helaas zijn er geen cursussen beschikbaar.",
        cursorStyle: "pointer",
        iconName: "book-off",
      };
    }

    if (isCurrentUser) {
      return {
        title: `Je heb nog geen cursussen`,
        description: "Helaas zijn er geen cursussen beschikbaar.",
        cursorStyle: "pointer",
        iconName: "book-off",
      };
    }

    if (!isPublic) {
      return {
        title: `${userName} heeft nog geen cursussen`,
        description: "Ga naar cursus om een cursus aan te maken of starten",
        cursorStyle: "default",
        iconName: "book-off",
      };
    }

    return {
      title: `Lead niet gevonden`,
      description: "We kunnen je gegevens niet vinden.",
      cursorStyle: "default",
      iconName: "user-cancel",
    };
  };

  const { title, description, cursorStyle, iconName } = getEmptyState();

  const handleClick = () => {
    if (userID === undefined) {
      navigationContext.handleNavigation({
        courseID: 0,
        navigation: 2,
        enrollment: 0,
      });
    }
  };

  return (
    <div className="empty-comp" onClick={handleClick} style={{ cursor: cursorStyle }}>
      <div className="empty-card">
        <div className="empty-icon">
          <IconAtom2
            style={{
              height: "60px",
              width: "60px",
              boxSizing: "border-box",
              color: "var(--error-500)",
              backgroundColor: "var(--error-100)",
            }}
            iconSize={40}
            icon2={iconName}
          />
        </div>
        <div className="empty-content">
          <p className="standard-text course-title bold-text grey-900 full-width">{title}</p>
          <p className="small-text progress-description grey-600 full-width">{description}</p>
        </div>
   </div>
   </div>
  );
}
